const HIGH_SCORE_KEY = "nretc_asphalt_paver_highscore";
const GRID_SIZE = 20;
const TICK_MS = {
  100: 160,
  75: 120,
  50: 92,
  25: 72,
  110: 136,
};

const gameArea = document.getElementById("game-area");
const modeSelect = document.getElementById("selectMode");
const modeWrapper = document.getElementById("mode-wrapper");

const canvas = document.createElement("canvas");
canvas.className = "nretc-asphalt-canvas";
gameArea.replaceChildren(canvas);

const ctx = canvas.getContext("2d");

let tileSize = 20;
let snake = [];
let direction = { x: 1, y: 0 };
let queuedDirection = { x: 1, y: 0 };
let food = { x: 8, y: 8 };
let score = 1;
let best = Number(localStorage.getItem(HIGH_SCORE_KEY) || 0);
let running = false;
let loopId = null;

function randomFreeCell() {
  while (true) {
    const cell = {
      x: Math.floor(Math.random() * GRID_SIZE),
      y: Math.floor(Math.random() * GRID_SIZE),
    };
    if (!snake.some((part) => part.x === cell.x && part.y === cell.y)) {
      return cell;
    }
  }
}

function resizeCanvas() {
  const size = Math.max(320, Math.min(gameArea.clientWidth || 720, gameArea.clientHeight || 720));
  canvas.width = size;
  canvas.height = size;
  tileSize = size / GRID_SIZE;
  draw();
}

function updateInfo(message) {
  modeWrapper.innerHTML = `
    <strong>Điểm:</strong> ${score}
    <span style="padding:0 12px;">|</span>
    <strong>Kỷ lục:</strong> ${best}
    <span style="padding:0 12px;">|</span>
    <span>${message}</span>
  `;
}

function drawGrid() {
  ctx.fillStyle = "#1f2933";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = "rgba(255,255,255,0.06)";
  ctx.lineWidth = 1;
  for (let i = 0; i <= GRID_SIZE; i += 1) {
    const offset = i * tileSize;
    ctx.beginPath();
    ctx.moveTo(offset, 0);
    ctx.lineTo(offset, canvas.height);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, offset);
    ctx.lineTo(canvas.width, offset);
    ctx.stroke();
  }
}

function drawSnake() {
  snake.forEach((part, index) => {
    const x = part.x * tileSize + 2;
    const y = part.y * tileSize + 2;
    const size = tileSize - 4;
    ctx.fillStyle = index === 0 ? "#f8c63d" : "#3b4148";
    ctx.strokeStyle = index === 0 ? "#8f6d00" : "#68727d";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.roundRect(x, y, size, size, 8);
    ctx.fill();
    ctx.stroke();
  });
}

function drawFood() {
  const x = food.x * tileSize + tileSize / 2;
  const y = food.y * tileSize + tileSize / 2;
  const radius = tileSize * 0.28;
  ctx.fillStyle = "#ff8c42";
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = "#fff4d1";
  ctx.beginPath();
  ctx.arc(x - radius * 0.35, y - radius * 0.35, radius * 0.35, 0, Math.PI * 2);
  ctx.fill();
}

function drawOverlay() {
  if (running) {
    return;
  }
  ctx.fillStyle = "rgba(7, 28, 57, 0.78)";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = "#ffffff";
  ctx.textAlign = "center";
  ctx.font = `700 ${Math.max(18, tileSize)}px Inter, Arial, sans-serif`;
  ctx.fillText("N-RETC Asphalt Paver", canvas.width / 2, canvas.height / 2 - 10);
  ctx.font = `500 ${Math.max(14, tileSize * 0.7)}px Inter, Arial, sans-serif`;
  ctx.fillText("Nhấn phím mũi tên hoặc cụm nút để bắt đầu", canvas.width / 2, canvas.height / 2 + 24);
}

function draw() {
  drawGrid();
  drawFood();
  drawSnake();
  drawOverlay();
}

function endGame(message) {
  running = false;
  if (loopId) {
    clearInterval(loopId);
    loopId = null;
  }
  if (score > best) {
    best = score;
    localStorage.setItem(HIGH_SCORE_KEY, String(best));
  }
  updateInfo(message);
  draw();
}

function tick() {
  direction = queuedDirection;
  const head = {
    x: snake[0].x + direction.x,
    y: snake[0].y + direction.y,
  };

  if (
    head.x < 0 ||
    head.y < 0 ||
    head.x >= GRID_SIZE ||
    head.y >= GRID_SIZE ||
    snake.some((part) => part.x === head.x && part.y === head.y)
  ) {
    endGame("Máy rải đã va chạm. Bấm nút điều hướng để chạy lại.");
    return;
  }

  snake.unshift(head);

  if (head.x === food.x && head.y === food.y) {
    score += 1;
    food = randomFreeCell();
    updateInfo("Đang thi công tuyến rải...");
  } else {
    snake.pop();
  }

  draw();
}

function startGame() {
  gameArea.focus({ preventScroll: true });
  snake = [
    { x: 5, y: 10 },
    { x: 4, y: 10 },
    { x: 3, y: 10 },
  ];
  direction = { x: 1, y: 0 };
  queuedDirection = { x: 1, y: 0 };
  food = randomFreeCell();
  score = 1;
  running = true;
  updateInfo("Đang thi công tuyến rải...");
  if (loopId) {
    clearInterval(loopId);
  }
  loopId = setInterval(tick, TICK_MS[modeSelect.value] || 120);
  draw();
}

function setDirection(nextX, nextY) {
  if (direction.x + nextX === 0 && direction.y + nextY === 0 && running) {
    return;
  }
  queuedDirection = { x: nextX, y: nextY };
  if (!running) {
    startGame();
  }
}

document.addEventListener("keydown", (event) => {
  const isGameKey = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "w",
    "W",
    "a",
    "A",
    "s",
    "S",
    "d",
    "D",
  ].includes(event.key);

  if (!isGameKey) {
    return;
  }

  const gameStage = document.getElementById("game-stage");
  const activeElement = document.activeElement;
  const isInsideGame =
    running ||
    gameStage.contains(event.target) ||
    (activeElement && gameStage.contains(activeElement));

  if (!isInsideGame) {
    return;
  }

  event.preventDefault();

  switch (event.key) {
    case "ArrowUp":
    case "w":
    case "W":
      setDirection(0, -1);
      break;
    case "ArrowDown":
    case "s":
    case "S":
      setDirection(0, 1);
      break;
    case "ArrowLeft":
    case "a":
    case "A":
      setDirection(-1, 0);
      break;
    case "ArrowRight":
    case "d":
    case "D":
      setDirection(1, 0);
      break;
    default:
      break;
  }
});

gameArea.addEventListener("pointerdown", () => {
  gameArea.focus({ preventScroll: true });
});

modeSelect.addEventListener("change", () => {
  if (running) {
    clearInterval(loopId);
    loopId = setInterval(tick, TICK_MS[modeSelect.value] || 120);
  }
  gameArea.focus();
});

window.addEventListener("resize", resizeCanvas);

resizeCanvas();
updateInfo("Sẵn sàng thi công. Chọn hướng để khởi động.");
draw();
